import axios from 'axios';
import { constants } from '@skunexus/utils';

const {
    CONFIG: { API_PATH },
} = constants;

export function repushProduct({ productId }) {
    return axios.post(`${API_PATH}/products/integration-repush`, {
        product_id: productId,
    });
}
